document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ashborn-product]').forEach(function (root) {
    const slides = Array.from(root.querySelectorAll('[data-ashborn-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-ashborn-thumb]'));
    const gallery = root.querySelector('[data-ashborn-gallery]');

    function getActiveIndex() {
      const activeSlide = root.querySelector('[data-ashborn-slide].is-active');
      if (!activeSlide) return 0;

      return Number(activeSlide.dataset.ashbornSlide || 0);
    }

    function showSlide(index) {
      const slideIndex = Number(index);

      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', Number(slide.dataset.ashbornSlide) === slideIndex);
      });

      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', Number(thumb.dataset.ashbornThumb) === slideIndex);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(thumb.dataset.ashbornThumb);
      });
    });

    if (gallery && slides.length > 1) {
      let touchStartX = 0;
      let touchEndX = 0;

      gallery.addEventListener(
        'touchstart',
        function (event) {
          touchStartX = event.changedTouches[0].screenX;
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchend',
        function (event) {
          touchEndX = event.changedTouches[0].screenX;

          const diff = touchStartX - touchEndX;
          let activeIndex = getActiveIndex();

          if (Math.abs(diff) < 45) return;

          if (diff > 0) {
            activeIndex = activeIndex + 1 >= slides.length ? 0 : activeIndex + 1;
          } else {
            activeIndex = activeIndex - 1 < 0 ? slides.length - 1 : activeIndex - 1;
          }

          showSlide(activeIndex);
        },
        { passive: true }
      );
    }

    const siblingList = root.querySelector('[data-ashborn-sibling-list]');
    const siblingPrev = root.querySelector('[data-ashborn-sibling-prev]');
    const siblingNext = root.querySelector('[data-ashborn-sibling-next]');

    function updateSiblingArrows() {
      if (!siblingList || !siblingPrev || !siblingNext) return;

      const maxScroll = siblingList.scrollWidth - siblingList.clientWidth;
      const currentScroll = siblingList.scrollLeft;

      siblingPrev.classList.toggle('is-hidden', currentScroll <= 4);
      siblingNext.classList.toggle('is-hidden', currentScroll >= maxScroll - 4);
    }

    if (siblingList && siblingPrev && siblingNext) {
      const activeSibling = siblingList.querySelector('.is-active');

      if (activeSibling) {
        const left =
          activeSibling.offsetLeft -
          siblingList.clientWidth / 2 +
          activeSibling.clientWidth / 2;

        siblingList.scrollTo({
          left: Math.max(left, 0),
          behavior: 'auto'
        });
      }

      siblingPrev.addEventListener('click', function () {
        siblingList.scrollBy({
          left: -180,
          behavior: 'smooth'
        });
      });

      siblingNext.addEventListener('click', function () {
        siblingList.scrollBy({
          left: 180,
          behavior: 'smooth'
        });
      });

      siblingList.addEventListener('scroll', updateSiblingArrows, { passive: true });
      window.addEventListener('resize', updateSiblingArrows);

      updateSiblingArrows();
    }

    root.querySelectorAll('.ashborn-accordion__trigger').forEach(function (button) {
      button.addEventListener('click', function () {
        const accordion = button.closest('.ashborn-accordion');
        if (!accordion) return;

        const isOpen = accordion.classList.contains('is-open');

        accordion.classList.toggle('is-open', !isOpen);
        button.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    const variantsEl = root.querySelector('[data-ashborn-variants]');
    const variantIdInput = root.querySelector('[data-ashborn-variant-id]');
    const addButton = root.querySelector('[data-ashborn-add]');
    const addText = root.querySelector('[data-ashborn-add-text]');
    const priceEl = root.querySelector('[data-ashborn-price]');
    const fourPayEl = root.querySelector('[data-ashborn-four-pay]');
    const threePayEl = root.querySelector('[data-ashborn-three-pay]');
    const productForm = root.querySelector('.ashborn-product__form');

    if (!variantsEl || !variantIdInput) return;

    let variants = [];
    let lastAddedKey = null;
    let toastTimer = null;

    try {
      variants = JSON.parse(variantsEl.textContent.trim());
    } catch (error) {
      variants = [];
    }

    function formatMoney(cents) {
      if (
        window.theme &&
        window.theme.Currency &&
        typeof window.theme.Currency.formatMoney === 'function' &&
        window.theme.moneyFormat
      ) {
        return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
      }

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      const currency =
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
          ? window.Shopify.currency.active
          : 'USD';

      return (Number(cents) / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency
      });
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function getSelectedOptions() {
      const selectedOptions = [];

      root.querySelectorAll('[data-ashborn-option-group]').forEach(function (group) {
        const checked = group.querySelector('input[type="radio"]:checked');

        if (checked) {
          selectedOptions.push(checked.value);
        }
      });

      return selectedOptions;
    }

    function findVariantByOptions(options) {
      return variants.find(function (variant) {
        if (!variant.options || variant.options.length !== options.length) return false;

        return variant.options.every(function (option, index) {
          return String(option) === String(options[index]);
        });
      });
    }

    function getCurrentVariant() {
      return variants.find(function (variant) {
        return String(variant.id) === String(variantIdInput.value);
      });
    }

    function updateSelectedClasses() {
      root.querySelectorAll('.ashborn-option__item').forEach(function (label) {
        const input = label.querySelector('input[type="radio"]');
        if (!input) return;

        label.classList.toggle('is-selected', input.checked);
      });
    }

    function updateAddButton(text, disabled) {
      if (!addButton) return;

      addButton.disabled = disabled;

      if (addText) {
        addText.textContent = text;
      } else {
        addButton.textContent = text;
      }
    }

    function updateVariantState() {
      const selectedOptions = getSelectedOptions();
      const matchedVariant = findVariantByOptions(selectedOptions);

      updateSelectedClasses();

      if (!matchedVariant) {
        updateAddButton('Unavailable', true);
        return;
      }

      variantIdInput.value = matchedVariant.id;

      if (priceEl) {
        priceEl.innerHTML = formatMoney(matchedVariant.price);
      }

      if (fourPayEl) {
        fourPayEl.innerHTML = formatMoney(Math.round(matchedVariant.price / 4));
      }

      if (threePayEl) {
        threePayEl.innerHTML = formatMoney(Math.round(matchedVariant.price / 3));
      }

      updateAddButton(matchedVariant.available ? 'Add to cart' : 'Sold Out', !matchedVariant.available);

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function getToast() {
      let toast = document.querySelector('[data-cart-added-toast]');

      if (toast) return toast;

      toast = document.createElement('div');
      toast.className = 'cart-added-toast';
      toast.setAttribute('data-cart-added-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');

      toast.innerHTML =
        '<span class="cart-added-toast__label">' +
          '<svg viewBox="0 0 24 24" focusable="false" role="presentation">' +
            '<circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.8"></circle>' +
            '<path d="M8 12.5 10.8 15.3 16.2 9.8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"></path>' +
          '</svg>' +
          'ITEM ADDED' +
        '</span>' +
        '<span class="cart-added-toast__content">' +
          '<span class="cart-added-toast__image" data-cart-added-toast-image=""></span>' +
          '<span class="cart-added-toast__copy">' +
            '<span class="cart-added-toast__title" data-cart-added-toast-title=""></span>' +
            '<span class="cart-added-toast__color" data-cart-added-toast-color=""></span>' +
            '<span class="cart-added-toast__size" data-cart-added-toast-size=""></span>' +
            '<span class="cart-added-toast__price" data-cart-added-toast-price=""></span>' +
            '<button type="button" class="cart-added-toast__undo" data-cart-added-toast-undo="">Undo</button>' +
          '</span>' +
        '</span>';

      document.body.appendChild(toast);

      const undoButton = toast.querySelector('[data-cart-added-toast-undo]');
      if (undoButton) {
        undoButton.addEventListener('click', undoLastAddedItem);
      }

      return toast;
    }

    function getColorText(item) {
      if (!item || !item.options_with_values) return '';

      const colorOption = item.options_with_values.find(function (option) {
        const name = String(option.name || '').toLowerCase();
        return name === 'color' || name === 'colour' || name === 'renk';
      });

      if (colorOption && colorOption.value) {
        return 'Color: ' + colorOption.value;
      }

      const activeSibling = root.querySelector('.ashborn-siblings__item.is-active .ashborn-siblings__title');
      if (activeSibling && activeSibling.textContent.trim()) {
        return 'Color: ' + activeSibling.textContent.trim();
      }

      const vendor = root.querySelector('.ashborn-product__vendor');
      if (vendor && vendor.textContent.trim()) {
        return 'Color: ' + vendor.textContent.trim();
      }

      return '';
    }

    function getSizeText(item) {
      if (!item || !item.options_with_values) return '';

      const sizeOption = item.options_with_values.find(function (option) {
        const name = String(option.name || '').toLowerCase();
        return name === 'size' || name === 'beden' || name === 'boyut';
      });

      if (sizeOption && sizeOption.value) {
        return 'Size: ' + sizeOption.value;
      }

      const currentVariant = getCurrentVariant();
      if (currentVariant && currentVariant.options && currentVariant.options.length) {
        return 'Size: ' + currentVariant.options[currentVariant.options.length - 1];
      }

      return '';
    }

    function getToastImage(item) {
      if (item && item.image) {
        return item.image;
      }

      const activeImage = root.querySelector('[data-ashborn-slide].is-active img');
      if (activeImage) {
        return activeImage.currentSrc || activeImage.src;
      }

      return '';
    }

    function showAddedToast(item) {
      const toast = getToast();

      const imageWrap = toast.querySelector('[data-cart-added-toast-image]');
      const titleEl = toast.querySelector('[data-cart-added-toast-title]');
      const colorEl = toast.querySelector('[data-cart-added-toast-color]');
      const sizeEl = toast.querySelector('[data-cart-added-toast-size]');
      const priceElToast = toast.querySelector('[data-cart-added-toast-price]');

      const image = getToastImage(item);
      const title = item && item.product_title ? item.product_title : root.querySelector('.ashborn-product__title')?.textContent.trim();
      const colorText = getColorText(item);
      const sizeText = getSizeText(item);
      const price = item && typeof item.final_line_price !== 'undefined'
        ? item.final_line_price
        : item && typeof item.price !== 'undefined'
          ? item.price
          : getCurrentVariant()
            ? getCurrentVariant().price
            : 0;

      if (imageWrap) {
        imageWrap.innerHTML = image
          ? '<img fetchpriority="high" decoding="async" loading="eager" alt="' + escapeHtml(title) + '" src="' + image + '">'
          : '';
      }

      if (titleEl) titleEl.textContent = title || '';
      if (colorEl) colorEl.textContent = colorText || '';
      if (sizeEl) sizeEl.textContent = sizeText || '';
      if (priceElToast) priceElToast.innerHTML = formatMoney(price);

      window.clearTimeout(toastTimer);

      toast.classList.add('is-visible');

      toastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 4200);
    }

    function updateCartCount(cart) {
      const countSelectors = [
        '[data-cart-count]',
        '.cart-link__bubble',
        '.site-header__cart-count',
        '.cart-count'
      ];

      countSelectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (countEl) {
          countEl.textContent = cart.item_count;
          countEl.classList.toggle('hide', cart.item_count === 0);
          countEl.classList.toggle('is-visible', cart.item_count > 0);
        });
      });
    }

    function refreshCartState() {
      return fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart could not be loaded');
          return response.json();
        })
        .then(function (cart) {
          updateCartCount(cart);

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                cart: cart
              }
            })
          );

          return cart;
        });
    }

    function undoLastAddedItem() {
      if (!lastAddedKey) return;

      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: lastAddedKey,
          quantity: 0
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Undo failed');
          return response.json();
        })
        .then(function (cart) {
          lastAddedKey = null;
          updateCartCount(cart);

          const toast = document.querySelector('[data-cart-added-toast]');
          if (toast) {
            toast.classList.remove('is-visible');
          }

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                cart: cart
              }
            })
          );
        });
    }

    function addToCartAjax(event) {
      if (!productForm || !addButton || addButton.disabled) return;

      event.preventDefault();

      const formData = new FormData(productForm);

      updateAddButton('Adding...', true);

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }

          return response.json();
        })
        .then(function (item) {
          lastAddedKey = item.key;
          showAddedToast(item);
          return refreshCartState();
        })
        .then(function () {
          updateAddButton('Added', false);

          window.setTimeout(function () {
            updateVariantState();
          }, 700);
        })
        .catch(function (error) {
          const message =
            error && error.description
              ? error.description
              : 'Could not add to cart';

          updateAddButton(message, false);

          window.setTimeout(function () {
            updateVariantState();
          }, 1800);
        });
    }

    if (productForm) {
      productForm.addEventListener('submit', addToCartAjax);
    }

    root.querySelectorAll('[data-ashborn-option]').forEach(function (input) {
      input.addEventListener('change', updateVariantState);
    });

    updateVariantState();
  });
});